import {MarketerTrackingRepositoryImpl} from '../repository/MarketerTrackingRepositoryImpl';
import type {SessionTrack} from '../models/session.model';

export class GetSessionTrackUseCase {
  private readonly repository = new MarketerTrackingRepositoryImpl();

  async execute (sessionId: number | string): Promise<SessionTrack> {
    return this.repository.getSessionTrack(sessionId);
  }
}
